import { useNavigate, useLocation } from "react-router-dom";
import { Home, Receipt, User, Gift } from "lucide-react";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { key: "home", label: "Home", icon: Home, path: "/customer/dashboard" },
    { key: "transactions", label: "Transactions", icon: Receipt, path: "/customer/transactions" },
    { key: "offers", label: "Offers", icon: Gift, path: "/customer/offers" },
    { key: "profile", label: "Profile", icon: User, path: "/customer/profile" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-40"
      style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(0,0,0,0.05)',
        boxShadow: '0 -4px 30px rgba(0,0,0,0.05)'
      }}
    >
      <div className="max-w-lg mx-auto grid grid-cols-4 h-16 px-2">
        {tabs.map(tab => {
          const Icon = tab.icon;
          const active = isActive(tab.path);
          return (
            <button
              key={tab.key}
              onClick={() => navigate(tab.path)}
              className={`relative flex flex-col items-center justify-center gap-1 transition-all duration-300 rounded-xl mx-1 ${
                active ? "text-white" : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {active && (
                <div 
                  className="absolute inset-1 rounded-xl -z-10"
                  style={{
                    background: 'linear-gradient(135deg, #1565C0 0%, #00BCD4 100%)'
                  }}
                />
              )}
              <Icon className={`h-5 w-5 ${active ? 'transform scale-110' : ''} transition-transform`} />
              <span className={`text-[10px] font-semibold ${active ? '' : ''}`}>{tab.label}</span>
            </button>
          );
        })}
      </div>
      {/* Safe area for iOS */}
      <div className="h-safe-area-inset-bottom bg-white" />
    </div>
  );
}
